import type { FormEvent } from "react";

import { Button, ButtonTypes } from "../basic/button";
import { Loading } from "../basic/loading";
import TextBox from "../basic/textBox";
import { LoginBackground } from "./background";

interface Props {
	password: string;
	setPassword: (value: string) => void;
	submitFunction: (event: FormEvent<HTMLFormElement>) => void;
	goBack?: () => void;
	loading: boolean;
	disabled: boolean;
	version?: string;
	error?: string;

	logoImage?: string;
	backgroundImage?: string;
}

export function ResetPasswordPage(props: Props) {
	const {
		password,
		setPassword,
		submitFunction,
		goBack,
		loading,
		disabled,
		version,
		error,
		logoImage,
		backgroundImage,
	} = props;

	return (
		<LoginBackground
			title="Reset Password"
			description="You must reset your password to continue. Enter a new password below."
			version={version}
			logoImage={logoImage}
			backgroundImage={backgroundImage}
		>
			<form className="tw-grid tw-gap-4" onSubmit={submitFunction}>
				<TextBox
					id="password"
					name="password"
					label="Password"
					value={password}
					changeHandler={setPassword}
					type="password"
					className="!tw-m-0"
					disabled={disabled}
				/>
				{error !== undefined && <span className="tw-text-sm tw-text-red-400">{error}</span>}
				<Loading loading={loading} message="Logging in...">
					<Button type="submit" className="tw-w-full" types={[ButtonTypes.Primary]} disabled={disabled}>
						Reset
					</Button>
				</Loading>
				{goBack && (
					<Button className="tw-w-full" types={[ButtonTypes.Outline]} onClick={goBack}>
						Go Back
					</Button>
				)}
			</form>
		</LoginBackground>
	);
}
